var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HJLegacy",attrs:{"id":this.uid}},[(_vm.legacycontent && _vm.legacycontent.html)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.legacycontent.html)}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }